module.exports = __webpack_public_path__ + "b43fec88de65dbfcd9cc179ace2a2144.svg";